module.exports = __webpack_public_path__ + "img/upload_image.339045b4.svg";